var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from '@emotion/styled';
import ActionButton from '../../../ActionButton';
import Button from '../../../Button';
var FooterWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 16px 20px 20px;\n"], ["\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 16px 20px 20px;\n"])));
/* forces icons to stay into these dimensions */
var IconWrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 36px;\n  height: 36px;\n"], ["\n  width: 36px;\n  height: 36px;\n"])));
var ButtonsWrapper = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  gap: 8px;\n  flex: 1;\n"], ["\n  display: flex;\n  gap: 8px;\n  flex: 1;\n"])));
var CustomCardFooterContent = function (props) {
    var _a;
    var footerProps = props.footerProps;
    if (!footerProps)
        return null;
    return (_jsxs(FooterWrapper, { children: [_jsxs(ButtonsWrapper, { children: [footerProps.actionButton && _jsx(ActionButton, __assign({}, footerProps.actionButton)), (_a = footerProps === null || footerProps === void 0 ? void 0 : footerProps.buttons) === null || _a === void 0 ? void 0 : _a.map(function (button) { return (_jsx(Button, __assign({}, button, { size: "small" }), button.label)); })] }), (footerProps === null || footerProps === void 0 ? void 0 : footerProps.icon) && _jsx(IconWrapper, { children: footerProps.icon })] }));
};
export default CustomCardFooterContent;
var templateObject_1, templateObject_2, templateObject_3;
